import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
//import ButtonBase from '@material-ui/core/ButtonBase';
import SubmitButton from 'components/SubmitButton';

import withAuthorization from 'components/Session/withAuthorization';
import { useFirebase } from 'components/Firebase/context';
//import UserAvatar from '../../components/UserAvatar';
import { useStripe } from '../../components/Stripe/StripeHookProvider';

import PasswordChangeForm from '../../components/PasswordChangeForm';
//import PaymentUpdateForm from './PaymentUpdateForm';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';

import TableRow from '@material-ui/core/TableRow';
import { typography } from '@material-ui/system';
import Button from '@material-ui/core/Button';
import ProfileUpdate from './ProfileUpdate';
import AddSubscription from './AddSubscription';
import { messages } from '../../../src/messages';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',

    maxWidth: 560,
  },
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  table: {
    minWidth: 320,
    maxWidth: 650
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = ((index) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
});

const Profile = (history, authUser) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const firebase = useFirebase();
  const stripe = useStripe();
  //const db = firebase.firestore();
  const [profile, setProfile] = useState({
    name: String, email: String
  });
  const [creds, setCreds] = useState({
    firstName: '',
    lastName: '',
  });
  //const [data, setData] = useState({profile: []});
  const [value, setValue] = React.useState(0);
  const [error, setError] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = index => {
    setValue(index);
  };
  const [showForm, setshowForm] = useState(false);
  const [profileMessage, setprofileMessage] = useState(null);
  const [showsubscription, setshowSubscription] = useState(false);
  // @ts-ignore
  const handleShow = (type) => {
    setshowForm(type);
  }
  const handleSubscription = (type) => {
    setshowSubscription(type);
  }
  useEffect(() => {
    const FetchProfile = async () => {
      const user = firebase.getProfile();
      const userData = await firebase.getUserDataById(user.uid).then((resp) => { return resp });
      console.log('userData', userData.user);
      const userName = userData.status == "success" ? (userData.user.firstName + ' ' + userData.user.lastName).toString() : "";
      // @ts-ignore
      setProfile({
        email: user.email,
        name: userName
      });
      setCreds({
        firstName: userData.user.firstName,
        lastName: userData.user.lastName
      });
    };
    FetchProfile();
  }, []);
  const onProfileChanged = (name, value) => {
    setCreds({ ...creds, [name]: value });
  };
  async function handleProfile() {
        try {
           // setLoader(true); 
           const { firstName, lastName } = creds;
            console.log(creds);
            if (firstName === "") { return  setError('Please enter first name'); }
            else if (lastName === "") {  return  setError('Please enter last name'); }
            else {
              const user = firebase.getProfile();
              await firebase.firestore
                .collection('users')
                .doc(user.uid)
                .set({ firstName: firstName, lastName: lastName,id: user.uid});
                const userName = firstName + ' ' + lastName;
                setProfile({
                    name: userName,
                    email: profile.email
                })
                setprofileMessage(messages.profileMessage);
                setTimeout(
                  function () {
                    setshowForm(false);
                  }
                    .bind(this),
                  5000
                );
            }
        } catch (e) {
          if (e.message) return setError(e.message);
        }
      }
  return (
    <div className={classes.root}>
      <Paper className={classes.paper} elevation={3}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="Profile" />
          <Tab label="Subscription" />
          <Tab label="Settings" />
        </Tabs>
        <TabPanel value={value} index={0} dir={theme.direction}>
        <Button variant="contained" color="primary" size="small"  onClick={type => handleShow(showForm ? false : true)}>
          {showForm ? 'Back' : 'Update Profile'}
          </Button>
          {showForm ? 
            <ProfileUpdate {...creds} profileMessage={profileMessage} error={error} handleProfile={handleProfile} onChanged={onProfileChanged}/>
          :  <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell variant="body">Name</TableCell>
                    <TableCell variant="body" children="">{profile.name}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell >Email</TableCell>
                    <TableCell children="">{profile.email}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          }
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
        <Button variant="contained" color="primary" size="small"  onClick={type => handleSubscription(showsubscription ? false : true)}>
          {showsubscription ? 'Back' : 'Add Subscription'}
          </Button>
          {showsubscription && <AddSubscription />}
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell>Plan</TableCell>
                  <TableCell> Free</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Status</TableCell>
                  <TableCell> Active </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <PasswordChangeForm></PasswordChangeForm>
        </TabPanel>
      </Paper>
    </div>
  );
};

export default withAuthorization()(Profile);
